import { Socials } from '@components/App/Modal/SeoPreview/components/Socials'
import {
  FacebookMonoLogo,
  LinkedinMonoLogo,
  XMonoLogo,
} from '@octopus-do/octopus-storybook/icons'
import type { SeoFormValues } from '@store/reducers/seo/types'
import type { AppState } from '@store/types'
import { useSelector } from 'react-redux'

export const useGetTabs = () => {
  const { url, description, title, image } = useSelector<
    AppState,
    SeoFormValues
  >(({ seoForm }) => seoForm)

  const link = new URL(url).hostname

  return [
    {
      tab: {
        title: 'Facebook',
        Icon: FacebookMonoLogo,
      },
      componentProps: {
        link,
        title,
        url,
        description,
        imageUrl: image?.value,
      },
      Component: Socials,
    },
    {
      tab: {
        title: 'Twitter',
        Icon: XMonoLogo,
      },
      componentProps: {
        link,
        title,
        url,
        description,
        imageUrl: image?.value,
        classname: 'twitter',
      },
      Component: Socials,
    },
    {
      tab: {
        title: 'LinkedIn',
        Icon: LinkedinMonoLogo,
      },
      componentProps: {
        link,
        title,
        url,
        description,
        imageUrl: image?.value,
        classname: 'linkedin',
      },
      Component: Socials,
    },
  ]
}
